import { useAuth0 } from "@auth0/auth0-react";
import { Box, CircularProgress } from "@mui/material";
import Auth0Error from "./Auth0Error";

/**
 * Displays a loading indicator when Auth0 is loading,
 * or an error if there was an issue signing in.
 * Otherwise, it displays the children.
 */
export default function LoadingComponent({ children }) {
    const { isLoading, error } = useAuth0();

    return isLoading || error ? (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {error ? <Auth0Error error={error} /> : <CircularProgress />}
        </Box>
    ) : (
        children
    );
}
